import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean, FctBytes4 } from '../../../../Fct/generics';
import { secureStorageAddresses } from '../helpers/constants';
export var SupportsInterface = createPlugin({
    protocol: 'SECURE_STORAGE',
    type: 'GETTER',
    method: 'supportsInterface',
    supportedContracts: secureStorageAddresses,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    interfaceId: new FctBytes4({}),
                },
            },
            output: {
                isSupports: new FctBoolean({}),
            },
        });
    },
});
